import * as React from 'react';

import Skeleton from 'react-loading-skeleton';

import {
  Colors,

  Text,
} from '@bluecurrent/web-component-lib';

export default function YAxis({
  text,
  isLoading,
}) {
  return (
    <div
      style={{
        height: 4,
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: 10,
      }}
    >
      <div
        style={{
          width: 5,
          height: 4,
          backgroundColor: Colors.MEDIUM_GREY,
        }}
      />
      {
        isLoading ? (
          <Skeleton
            height={17.5}
            width={55}
          />
        ) : (
          <Text
            fontSize="1em"
            color="#88888D"
          >
            {text}
          </Text>
        )
      }
    </div>
  );
}
